import { parsePopupCustomTextCellKey } from "./popupCustomText";

/**
 * Answers whether custom text is the active value of a cell, from the saved
 * overrides keyed as the editor keys them (the displayed row's benefit key,
 * with the plan column's network).
 */
export const buildCustomTextActivityLookup = (
  customTextByCellKey: ReadonlyMap<string, string>,
): ((planId: string, benefitKey: string, network?: string) => boolean) => {
  const cellsWithCustomText = new Set<string>();
  customTextByCellKey.forEach((customText, cellKey) => {
    const identity = parsePopupCustomTextCellKey(cellKey);
    if (identity && customText) {
      cellsWithCustomText.add(
        `${identity.benefitPlanId}::${identity.benefitKey}::${identity.network ?? ""}`,
      );
    }
  });

  return (planId, benefitKey, network) =>
    cellsWithCustomText.has(`${planId}::${benefitKey}::${network ?? ""}`);
};
